<template>
  <h1>You will be redirected soon..</h1>
</template>

<script>
export default {
  created () {
    this.$store.dispatch('swiftuser/onHomePageHit', this.$route.params);
    this.$router.push({ name: 'HomePage' });
  },
};
</script>
